import { DataBean } from "../../DataBean";


export class ExportPilaDataFiles extends DataBean {

    public async exportPilaDataFiles(idSocialSecuritySpreadSheet: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportPilaDataFiles_Number_Number", [idSocialSecuritySpreadSheet, idEmployee]);
    }

}